import React from 'react';
import * as d3 from "./d3.modified.js";

export default class UberLink extends React.Component {
    static genLine(_x1, _y1, _x2, _y2) {
        const curvedLine = d3.line().curve(d3.curveBasis)
        const MIN_BEND = 10
        const MAX_BEND = 200

        var diff = Math.abs(_x1 - _x2) * 0.3 + MIN_BEND
        diff = diff > MAX_BEND
                  ? MAX_BEND
                  : diff

        var newPoints = []
        newPoints.push([        _x1, _y1])
        newPoints.push([ diff + _x1, _y1])
        newPoints.push([-diff + _x2, _y2])
        newPoints.push([        _x2, _y2])
        return curvedLine(newPoints)
    }

    componentDidMount() {
        this.path.on('dblclick', ()=>{
            d3.event.stopPropagation()
            this.props.removeLink(this.props.data)
        })
    }

    render() {

        return (
            <g>
                <path
                    className="uber-link-catcher"
                    ref={c=>{this.path=d3.select(c); this.props.data.path=d3.select(c)}}
                    d={UberLink.genLine(this.props.data.x1, this.props.data.y1, this.props.data.x2, this.props.data.y2)}
                />
                <path
                    className="uber-link"
                    // ref={c=>{this.path=d3.select(c); this.props.data.path=d3.select(c)}}
                    d={UberLink.genLine(this.props.data.x1, this.props.data.y1, this.props.data.x2, this.props.data.y2)}
                />
            </g>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/UberLink.js